import { createFileRoute } from '@tanstack/react-router'

import { parseHistoryPage } from '@/lib/utils/history-search'

import PageWorkflowHistory from '../pages/PageWorkflowHistory'

type WorkflowHistorySearch = {
  creator?: string
  page: number
  search: string
  character: string
  status: string
  folderId: string
}

export const Route = createFileRoute('/workflow-history')({
  validateSearch: (search: Record<string, unknown>): WorkflowHistorySearch => ({
    creator: typeof search.creator === 'string' ? search.creator : '',
    page: parseHistoryPage(search.page),
    search: typeof search.search === 'string' ? search.search : '',
    character: typeof search.character === 'string' && search.character ? search.character : 'ALL',
    status: typeof search.status === 'string' && search.status ? search.status : 'ALL',
    folderId: typeof search.folderId === 'string' && search.folderId ? search.folderId : 'ALL'
  }),
  component: PageWorkflowHistory
})
